import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({displayState}) => css`
    width: ${displayState?.width ?? '100%'};
    height: ${displayState?.height ?? ''};
    border: 1px dashed #E3E3E3;
    border-radius: ${displayState?.borderRadius ?? '4px'};
  `}
`;

export default Wrapper(template);